import { render, staticRenderFns } from "./PCG.vue?vue&type=template&id=feb36372&scoped=true&"
import script from "./PCG.vue?vue&type=script&lang=js&"
export * from "./PCG.vue?vue&type=script&lang=js&"
import style0 from "./PCG.vue?vue&type=style&index=0&id=feb36372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb36372",
  null
  
)

export default component.exports